export default __webpack_public_path__ + "static/media/error.efef1905.svg";